import React from 'react';
import { Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { MinusIcon, PlusIcon } from '@/assets/icons/v2';
import { ZoomButton, ZoomControl, ZoomSlider } from './styles';

const MIN_ZOOM = 1;
const MAX_ZOOM = 4;
const ZOOM_STEP = 0.5;

interface ZoomProps {
	zoom: number;
	onChange: (zoom: number) => void;
}

export function Zoom({ zoom, onChange }: Readonly<ZoomProps>): JSX.Element {
	function handleDecrease(): void {
		const next = Math.max(zoom - ZOOM_STEP, MIN_ZOOM);

		onChange(next);
	}

	function handleIncrease(): void {
		const next = Math.min(zoom + ZOOM_STEP, MAX_ZOOM);

		onChange(next);
	}

	return (
		<Row justify="end">
			<ZoomControl>
				<ZoomButton
					type="text"
					icon={<MinusIcon />}
					disabled={zoom === MIN_ZOOM}
					onClick={handleDecrease}
					aria-label={I18n.get('Zoom out')}
				/>
				<ZoomSlider
					min={MIN_ZOOM}
					max={MAX_ZOOM}
					step={ZOOM_STEP}
					value={zoom}
					tooltip={{ open: false }}
					onChange={onChange}
				/>
				<ZoomButton
					type="text"
					icon={<PlusIcon />}
					disabled={zoom === MAX_ZOOM}
					onClick={handleIncrease}
					aria-label={I18n.get('Zoom in')}
				/>
			</ZoomControl>
		</Row>
	);
}
